import { IconButton, Tooltip } from '@material-ui/core';
import L from 'leaflet';
import React, {
	ReactElement,
	MouseEvent,
	RefObject,
	createRef,
	useEffect
} from 'react';

import './tooltip-icon-button.styles.scss';

export interface ITooltipIconButtonProps {
	tooltip: string;
	selected?: boolean | undefined;
	disabled?: boolean | undefined;
	icon: ReactElement;
	placement?:
		| 'bottom-end'
		| 'bottom-start'
		| 'bottom'
		| 'left-end'
		| 'left-start'
		| 'left'
		| 'right-end'
		| 'right-start'
		| 'right'
		| 'top-end'
		| 'top-start'
		| 'top';
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export function TooltipIconButton(
	props: ITooltipIconButtonProps
): ReactElement {
	const { tooltip, selected, disabled, icon, placement, onClick } = props;
	const buttonRef: RefObject<HTMLButtonElement> =
		createRef<HTMLButtonElement>();

	useEffect(() => {
		if (buttonRef.current) {
			L.DomEvent.disableClickPropagation(buttonRef.current);
		}
	}, [buttonRef]);

	return (
		<Tooltip title={tooltip} placement={placement}>
			<span>
				<IconButton
					color="primary"
					ref={buttonRef}
					className={`tooltip-icon-button ${
						selected ? 'selected' : ''
					} ${disabled ? 'disabled' : ''}`}
					onClick={onClick}
					disabled={disabled}
				>
					{icon}
				</IconButton>
			</span>
		</Tooltip>
	);
}
